import { Link } from "react-router-dom";

const ResetSuccessfully = () => {
  return (
    <div className="login_wepper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 p-0">
            <div className="login_inner_wepper">
              <div className="reset_successfully_svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  fill="none"
                >
                  <g clipPath="url(#clip0_35_1228)">
                    <path
                      d="M22.8333 42.0373L29.4292 35.9373C37.1542 39.6707 42.0458 42.5123 50.7208 48.6998C67.0375 30.1915 77.8167 20.7998 97.85 8.33317L100 13.2748C83.4792 27.6915 71.375 43.7498 53.9542 74.9998C43.2083 62.3415 36.0333 54.2748 22.8333 42.0373ZM82.8625 44.3582C83.1417 46.204 83.3333 48.079 83.3333 49.9998C83.3333 70.6748 66.5083 87.4998 45.8333 87.4998C25.1583 87.4998 8.33333 70.6748 8.33333 49.9998C8.33333 29.3248 25.1583 12.4998 45.8333 12.4998C54.0458 12.4998 61.625 15.1832 67.8083 19.679C69.9792 17.8207 72.1917 16.0082 74.475 14.2498C66.625 7.954 56.6792 4.1665 45.8333 4.1665C20.5208 4.1665 0 24.6873 0 49.9998C0 75.3123 20.5208 95.8332 45.8333 95.8332C71.1458 95.8332 91.6667 75.3123 91.6667 49.9998C91.6667 45.0873 90.875 40.3623 89.4417 35.9248C87.2417 38.5623 85.0583 41.3623 82.8625 44.3582Z"
                      fill="#27D095"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_35_1228">
                      <rect width="100" height="100" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h2>Reset Successfully</h2>
                <p>
                  Your Unboxed Gifts log in password has been updated
                  successfully
                </p>
              </div>

              <form action="">
                <div className="row from_wepper">
                  <div className="col-lg-12 submit_btn">
                    <input
                      type="submit"
                      id=""
                      name=""
                      value="Continue to login"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-6 p-0">
            <div className="login_img_data">
              <img src="images/right-login.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetSuccessfully;
